import { PlatformMessage } from '@reachmedianetwork/post-message-client-rds-api';
import {
    RequiredInterfaces,
    RootStorageFilesInterface,
    TeamviewerInterface,
    UpdateInterface,
} from '../interfaces';
import { ReloadInterface } from '../interfaces/ReloadInterface';
import { Permission } from '../Permissions';
import { Feature, hasUrlQueryFeature, isUrlQueryPlatform } from '../PlatformCheck';
import { PlayerPmc } from '../PlayerPmc';

export class ReachPmcPlayer
    extends PlayerPmc
    implements
        RequiredInterfaces,
        TeamviewerInterface,
        RootStorageFilesInterface,
        ReloadInterface,
        UpdateInterface
{
    readonly name = 'REACH Player';
    constructor() {
        super();
        this.addPermission(Permission.VLC_RTP);
        this.addPermission(Permission.VLC_RTMP);
        this.addPermission(Permission.VLC_HDMI);
        this.addPermission(Permission.RELAXED_NET_SECURITY);
    }

    static isTheRunningPlatform(): boolean {
        const thisPlatformIsRunning = isUrlQueryPlatform('Reach');
        const thisPlatformSupportsPmc = hasUrlQueryFeature(Feature.PostMessageClient);
        return thisPlatformIsRunning === true && thisPlatformSupportsPmc;
    }

    async _generateAndGetHardwareId(): Promise<string> {
        const { uniqueIdentifier } = await this.postMessage(
            PlatformMessage.DeviceInformationGet,
            undefined
        );
        const hardwareId = uniqueIdentifier
            .split(',')
            .map((identifier) => identifier.toLocaleLowerCase())
            .sort()
            .reduce((acc, next) => acc + next, '');
        return `REACH://${hardwareId}`;
    }
}
